// Generated by purs version 0.15.15
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var Seconds = function (x) {
    return x;
};
var showSeconds = Data_Time_Duration.showSeconds;
var ordSeconds = Data_Time_Duration.ordSeconds;
var newtypeSeconds = {
    Coercible0: function () {
        return undefined;
    }
};
var udecodeSeconds = {
    unsafeDecode: /* #__PURE__ */ (function () {
        var $8 = Unscramble.unsafeDecode(Unscramble.decodeNumber1);
        return function ($9) {
            return wrap(wrap($8($9)));
        };
    })()
};
var eqSeconds = Data_Time_Duration.eqSeconds;
var encodeSeconds = {
    encode: /* #__PURE__ */ (function () {
        var $10 = Foreign_Generic_Class.encode(Foreign_Generic_Class.numberEncode);
        return function ($11) {
            return $10(unwrap(unwrap($11)));
        };
    })()
};
var decodeSeconds = {
    decode: /* #__PURE__ */ (function () {
        var $12 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(function ($15) {
            return wrap(wrap($15));
        });
        var $13 = Foreign_Generic_Class.decode(Foreign_Generic_Class.numberDecode);
        return function ($14) {
            return $12($13($14));
        };
    })()
};
export {
    Seconds,
    newtypeSeconds,
    eqSeconds,
    ordSeconds,
    showSeconds,
    encodeSeconds,
    decodeSeconds,
    udecodeSeconds
};
